
// import {fire, fireAuth} from '@/firebase/config'
import { useStore } from "vuex";
import { onMounted, ref, provide } from "vue";
import { useRouter, useRoute } from "vue-router";
import useCss from "@/composables/useCss";

export default {
  // components: [],
  setup() {
    const router = useRouter();
    // const ss = useStore().state;
    // const sg = useStore().getters;
    ///////////////////////

    ///////////css////////////
    const { count, slide, cqueA, cque, devToggle } = useCss();
    // css import

    // const barsDrop = cque(".barsDrop");
    const barsDropToggle = () => {
      //action
      console.log(cque(".barsDrop"));
      const elem = cque(".barsDrop");
      if (elem) {
        //max-width
        elem.classList.toggle("maxh0");
        elem.classList.toggle("maxh400");
      }
    };

    const changeTheme = () => {
      const body = document.querySelector("body");
      if (body) {
        body.classList.toggle("lightTheme");
        body.classList.toggle("darkTheme");
      }
    };

    // const devToggle = () => {
    //   const devs = cqueA(".dev");
    //   devs.forEach(item => {
    //     item.classList.toggle("devNone");
    //   });
    // };

    onMounted(() => {
      //elements
      ////////////////////////////////////
      // const barsDrop = ref(cque(".barsDrop"));
      // console.log(barsDrop.value);
    });
    ////////////////////////
    return {
      // ss, sg
      router,
      barsDropToggle,
      devToggle,
      changeTheme
    };
  }
};
